import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraIconButton } from '../ensigns/icon-button';
import { SpecraHeading, SpecraText } from '../ensigns/typography';
/** Shared heading for dialogs, drawers, and focused detail surfaces. */ export const SpecraOverlayHeader = /*#__PURE__*/ React.forwardRef(({ actions, className, closeLabel = 'Close', description, descriptionAsChild = false, eyebrow, onClose, title, titleAsChild = false, ...props }, ref)=>/*#__PURE__*/ _jsxs("header", {
        className: cn('flex items-start gap-3 border-b border-border px-4 py-3 sm:px-5 sm:py-4', className),
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    eyebrow ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "mb-1 block uppercase tracking-[var(--ls-ui-eyebrow)]",
                        size: "micro",
                        tone: "muted",
                        children: eyebrow
                    }) : null,
                    titleAsChild ? title : /*#__PURE__*/ _jsx(SpecraHeading, {
                        size: "sm",
                        children: title
                    }),
                    description ? descriptionAsChild ? description : /*#__PURE__*/ _jsx(SpecraText, {
                        as: "p",
                        className: "mt-1",
                        size: "caption",
                        tone: "muted",
                        children: description
                    }) : null
                ]
            }),
            actions ? /*#__PURE__*/ _jsx("div", {
                className: "flex max-w-[var(--component-overlay-actions-max-width)] flex-wrap justify-end gap-1",
                children: actions
            }) : null,
            onClose ? /*#__PURE__*/ _jsx(SpecraIconButton, {
                label: closeLabel,
                onClick: onClose,
                variant: "ghost",
                children: "×"
            }) : null
        ]
    }));
SpecraOverlayHeader.displayName = 'SpecraOverlayHeader';
